export default "__VITE_ASSET__psTqn2DQ__"